import React from 'react';
const ImageHostContext = React.createContext<string>('');
export default ImageHostContext;
